import { MapPin, Phone, ArrowLeft } from "lucide-react";

/*
 * LocationSuburbs — Section 7/10 for /garage-door-repair-canterbury-bankstown/
 * MASTER TEMPLATE — duplicate for other locations, change only the LOC block.
 * Paste this ENTIRE file into src/pages/GarageDoorRepairCanterburyBankstown/sections/LocationSuburbs.tsx
 */

// ╔══════════════════════════════════════════════════════════════════╗
// ║  LOC CONFIG — change ONLY this block when duplicating          ║
// ╚══════════════════════════════════════════════════════════════════╝
const LOC = {
  name: "Canterbury-Bankstown",
  count: "15+",
  h2: "Every Canterbury-Bankstown Suburb We Service",
  subtitle: "Our home turf — if it\'s in Canterbury-Bankstown, we can be there in minutes.",
  suburbs: ["Bankstown", "Bankstown Aerodrome", "Bass Hill", "Yagoona", "Birrong", "Sefton", "Chester Hill", "Villawood", "Leightonfield", "Condell Park", "Revesby", "Revesby Heights", "Padstow", "Padstow Heights", "Panania", "East Hills", "Picnic Point", "Milperra", "Greenacre", "Mount Lewis", "Punchbowl", "Lakemba", "Wiley Park", "Belmore", "Campsie", "Canterbury", "Kingsgrove", "Earlwood", "Roselands", "Narwee", "Beverly Hills"],
  nearby: [{
    name: "South Sydney",
    href: "/garage-door-repair-south-sydney/"
  }, {
    name: "Western Sydney",
    href: "/garage-door-repair-western-sydney/"
  }, {
    name: "Inner West",
    href: "/garage-door-repair-inner-west/"
  }]
};
// ╚══════════════════════════════════════════════════════════════════╝

const GOLD = "#F5A623";
const NAVY = "#081438";
const NAVY2 = "#0f2347";
export default function LocationSuburbs() {
  return <section id="location-suburbs" style={{
    background: NAVY,
    position: "relative",
    overflow: "hidden"
  }}>

      {/* Wave top — DUPLICATE from LocationWhyUs bottom */}
      <div style={{
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        width: "100%",
        display: "block"
      }}>
          <path d="M0,60 C360,0 1080,0 1440,60 L1440,0 L0,0 Z" fill="#FAF7F1" />
        </svg>
      </div>

      {/* Grain */}
      <svg aria-hidden="true" style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none",
      zIndex: 1
    }}>
        <filter id="lsub-grain"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#lsub-grain)" />
      </svg>

      {/* Scanlines */}
      <div aria-hidden="true" style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg,transparent,${GOLD}60,transparent)`,
      zIndex: 2
    }} />
      <div aria-hidden="true" style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg,transparent,${GOLD}60,transparent)`,
      zIndex: 2
    }} />

      {/* Watermark */}
      <div aria-hidden="true" style={{
      position: "absolute",
      bottom: "-2%",
      right: "-2%",
      fontSize: "clamp(80px,14vw,200px)",
      fontWeight: 900,
      color: `${GOLD}0A`,
      lineHeight: 1,
      fontFamily: "Plus Jakarta Sans,sans-serif",
      pointerEvents: "none",
      zIndex: 1,
      userSelect: "none"
    }}>
        {LOC.count}
      </div>

      <div style={{
      position: "relative",
      zIndex: 3,
      maxWidth: "1280px",
      margin: "0 auto",
      padding: "clamp(56px,7vw,88px) clamp(20px,5vw,48px)"
    }}>

        {/* Header */}
        <div style={{
        textAlign: "center",
        marginBottom: "40px"
      }}>
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px"
        }}>
            <div style={{
            width: "32px",
            height: "2px",
            background: GOLD
          }} />
            <span style={{
            fontFamily: "Manrope,sans-serif",
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: `${GOLD}BB`
          }}>
              {LOC.count} Suburbs Covered
            </span>
            <div style={{
            width: "32px",
            height: "2px",
            background: GOLD
          }} />
          </div>
          <h2 style={{
          fontFamily: "Plus Jakarta Sans,sans-serif",
          fontWeight: 800,
          fontSize: "clamp(26px,3.5vw,42px)",
          lineHeight: 1.1,
          color: "#FFFFFF",
          marginBottom: "12px"
        }}>
            {LOC.h2}
          </h2>
          <p style={{
          fontFamily: "Manrope,sans-serif",
          fontSize: "clamp(14px,1.5vw,16px)",
          color: "rgba(255,255,255,0.6)",
          lineHeight: 1.7,
          maxWidth: "500px",
          margin: "0 auto"
        }}>
            {LOC.subtitle}
          </p>
        </div>

        {/* Suburb chips — full list for SEO */}
        <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        justifyContent: "center",
        marginBottom: "40px"
      }}>
          {LOC.suburbs.map(s => <span key={s} style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "5px",
          background: "rgba(255,255,255,0.06)",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: "999px",
          padding: "6px 14px",
          fontFamily: "Manrope,sans-serif",
          fontSize: "13px",
          color: "rgba(255,255,255,0.7)",
          fontWeight: 500
        }}>
              {/** @preserve lucide-do-not-replace */}
              <span data-icon-container="lucide-do-not-replace"><MapPin size={10} color={GOLD} strokeWidth={2} /></span>
              {s}
            </span>)}
        </div>

        {/* "Not listed?" fallback */}
        <div style={{
        textAlign: "center",
        marginBottom: "44px"
      }}>
          <p style={{
          fontFamily: "Manrope,sans-serif",
          fontSize: "14px",
          color: "rgba(255,255,255,0.55)",
          marginBottom: "12px"
        }}>
            Your suburb not listed? We probably still cover it.
          </p>
          <a href="tel:0485000933" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          color: GOLD,
          fontFamily: "Manrope,sans-serif",
          fontSize: "14px",
          fontWeight: 700,
          textDecoration: "none"
        }}>
            {/** @preserve lucide-do-not-replace */}
            <span data-icon-container="lucide-do-not-replace"><Phone size={15} color={GOLD} strokeWidth={2.5} /></span>
            Call 0485 000 933 to check
          </a>
        </div>

        {/* Nearby areas — internal linking for SEO */}
        <div style={{
        borderTop: `1px solid ${GOLD}20`,
        paddingTop: "32px"
      }}>
          <p style={{
          fontFamily: "Manrope,sans-serif",
          fontSize: "12px",
          fontWeight: 700,
          color: "rgba(255,255,255,0.4)",
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          textAlign: "center",
          marginBottom: "16px"
        }}>
            Nearby Service Areas
          </p>
          <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          justifyContent: "center"
        }}>
            {LOC.nearby.map(n => <a key={n.name} href={n.href} style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            background: NAVY2,
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "8px",
            padding: "10px 16px",
            textDecoration: "none",
            transition: "border-color 0.2s"
          }} className="hover:!border-[#F5A623]/40">
                {/** @preserve lucide-do-not-replace */}
                <span data-icon-container="lucide-do-not-replace"><MapPin size={13} color={GOLD} strokeWidth={2} /></span>
                <span style={{
              fontFamily: "Manrope,sans-serif",
              fontSize: "13px",
              color: "rgba(255,255,255,0.7)",
              fontWeight: 600
            }}>{n.name}</span>
              </a>)}
            <a href="/service-areas/" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            background: `${GOLD}15`,
            border: `1px solid ${GOLD}30`,
            borderRadius: "8px",
            padding: "10px 16px",
            textDecoration: "none"
          }}>
              {/** @preserve lucide-do-not-replace */}
              <span data-icon-container="lucide-do-not-replace"><ArrowLeft size={13} color={GOLD} strokeWidth={2} /></span>
              <span style={{
              fontFamily: "Manrope,sans-serif",
              fontSize: "13px",
              color: GOLD,
              fontWeight: 700
            }}>All Service Areas</span>
            </a>
          </div>
        </div>
      </div>

      {/* Wave bottom — DUPLICATE in LocationReviews top */}
      <div style={{
      position: "relative",
      zIndex: 3,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        width: "100%",
        display: "block"
      }}>
          <path d="M0,0 C360,60 1080,60 1440,0 L1440,60 L0,60 Z" fill="#FAF7F1" />
        </svg>
      </div>
    </section>;
}